import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { useTheme, jsx } from '@emotion/react';
import Style from './style.js';

var _excluded = ["displayInline", "IconComponent", "rotate"];
var Icon = _ref => {
  var {
    displayInline = false,
    IconComponent,
    rotate = 0
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return jsx(IconComponent, _extends({
    css: Style.iconStyles({
      displayInline,
      fill: rest.fill,
      rotate
    })
  }, rest));
};
var useIcon = (PrimaryIcon, SecondaryIcon, props) => {
  var theme = useTheme();
  var ThemeIcon = theme.__type === 'primary' || theme.__type === 'tertiary' ? PrimaryIcon : SecondaryIcon;
  if (ThemeIcon === null) return null;
  return jsx(Icon, _extends({
    IconComponent: ThemeIcon
  }, props));
};

export { Icon, useIcon };
